<template>
  <div class="activityFinish">
    <div class="activity_top">
      <img src="../../../assets/images/invitePage/body1.png">
      <div class="rule" style="" v-on:click="clickRule">规则</div>
    </div>
    <div class="activity_bottom">
      <img class="activity_bottom_background" src="../../../assets/images/invitePage/body2.png">
      <div class="activity_bottom_content">
        <div class="title_image">
          <img src="../../../assets/images/Lottery/myPrize.png" height="36" width="166" alt="">
        </div>
        <div class="prise_top_content">
          <img :src= this.prizePicture>
        </div>
        <div class="prise_top_bottom">
          <p>{{this.prizeName}}</p>
        </div>
        <div class="prise_bottom">
          <div v-if="isPrise == false" class="prise_bottom_fail">
            <p>没有中奖并不代表您的运气不好 <br>或许这是守得云开见月明的开始</p>
          </div>
          <div v-else class="prise_bottom_success">
            <div>
              <p class="text_input">{{this.remarks}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <InviteRule v-if="isShowRule" @onClose="onClose"></InviteRule>
  </div>
</template>

<script>

import {userPageStatus, userPrize} from "../../../common/constant"
import InviteRule from "../../../components/ruleAlert/inviteRule.vue"

export default {
  name: 'activityFinishPage',
  components:{ InviteRule },
  data() {
    return {
      isPrise: true,
      userId: '',
      prizeName: '',
      prizePicture: '',
      remarks: '',
      isShowRule: false,
    }
  },
  methods: {
    async fetchUserPrise() {
      this.userId = this.$route.query.userId;
      const postData = {userId: this.userId}
      const res = await this.$http.post(userPrize,postData)
      if (res.code == 0) {
        this.isPrise = res.data.status;
        this.prizeName = res.data.prizeName;
        this.prizePicture = res.data.prizePicture;
        this.remarks = res.data.remarks.replace(/\n/g, '<br>') || res.data.remarks.replace(/\r\n/g, '<br>') || res.data.remarks.replace(/\r/g, '<br>') ;
        document.getElementsByClassName("text_input")[0].innerHTML = this.remarks;
      }
    },
    async fetchUserPageStatus() {
      const res = await this.$http.get(userPageStatus);
      this.userId = parseInt(this.$route.query.userId);
      if(res.code == 0) {
        if(res.data.pageStatus != 3 && res.data.pageStatus != 0) {
          if(res.data.pageStatus == 1) {
            this.$router.replace( `/poster?userId=${this.userId}`)
          }
          if (res.data.pageStatus == 2) {
            this.$router.replace( `/lottery?userId=${this.userId}`)
          }
        }
      }
    },
    clickRule:function(){
      // window.location.href = "http://ryere.cn/activity/rule.html"
      this.isShowRule = true;
      //禁用body滚动
      document.getElementsByTagName("body")[0].style.overflow = "hidden"
    },
    onClose() {
      this.isShowRule = false;
      document.getElementsByTagName("body")[0].style.overflow = "scroll"
    },
  },
  created() {
    this.fetchUserPrise();
  },
  mounted() {
    this.fetchUserPageStatus()
  }
}

</script>

<style lang="less" scoped>
.activityFinish {
  height: 100%;
  background-color: white;
}

.activity_top {
  position: absolute;
  height: 406px;
  width: 100%;
  img {
    height: 100%;
    width: 100%;
  }
}
.rule{
  background-color: rgba(0,0,0,0.4);
  position: absolute;
  right:0;
  top:78px;
  width: 1rem;
  color: white;
  padding: 4px;
  border-radius: 6px 0 0 6px;
}
.activity_bottom {
  margin-top: -1px;
  position: absolute;
  top: 406px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .activity_bottom_background {
    max-width: 100%;
    height: 700px;
  }
  .activity_bottom_content {
    position: absolute;
    top: 0;
    background-color: white;
    left: 16px;
    right: 16px;
    min-height: 527px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    .title_image {
      position: relative;
      top: -10px;
      display: flex;
      justify-content: center;
    }
    .prise_top_content {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100px;
      justify-content: center;
      align-items: center;
      margin-top: 12px;
      img {
        width: 137px;
        height: 100px;
        object-fit: contain;
      }
    }
    .prise_top_bottom {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 5px;
      p {
        color: black;
        font-size: 16px;
        font-weight: bold;
      }
    }
    .prise_bottom {
      display: flex;
      background-color: white;
      width: 100%;
      max-height: 100%;
      margin-top: 12px;
      flex-direction: column;
      border-radius: 16px;
      .prise_bottom_fail {
        margin-top: 60px;
        margin-bottom: 10px;
        justify-content: center;
        overflow: hidden;
        p{
          color: #91A0B6;
          font-size: 16px;
          text-align: center;
        }
      }
      .prise_bottom_success {
        margin-left: 12px;
        margin-right: 12px;
        margin-top: 16px;
        max-height: 90%;
        overflow: hidden;

        .text_input {
          width: 100%;
          display: block;
          font-size: 16px;
          line-height: 30px;
        }
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/views/gameLottery/activityFinished/activityFinishPage.vue